import React, { useEffect, useState } from "react";
import { Row, Col, Form, InputNumber, Progress, Spin, Modal } from "antd";
import { withRouter } from 'react-router-dom';
import "./BulkFxUpdateRxModal.scss";

import Icon from "antd/es/icon";
import moment from "moment";

import { connect } from "react-redux";

import { FormattedMessage, useIntl, FormattedDate } from "react-intl";
import { setModalVisible, setRemainingTime, setSourceCurrency, setTargetCurrency, setOrderIds, setTime, 
    setTotalSourceAmount, setTotalConvertedAmount, setTotalTargetAmount, setTotalRemitFees, callLockExchangeRate, callUpdateExchangeRate } from "../rx/bulkfxupdate";

import FieldValueVerticalRxCell from "./FieldValueVerticalRxCell";
import { formatMoney, displayNumberWithComma, formatDouble } from 'utils/utils';
import {displayError} from "../common/notifications";
import {cleanError, cleanSuccess} from "../rx/bulkfxupdate/bulkFxUpdateAction";

import config from "../config";

const confirm = Modal.confirm;

function BulkFxUpdateRxModal(props) {
    const intl = useIntl();

    let currentDateTime = new Date();
    let dateTemp  = currentDateTime.toLocaleString("en-US", {timeZone: "Asia/Singapore"});
    let currentDate = moment(dateTemp).format("DD MMMM YYYY");

    // countdown every 10 seconds
    const [timeLeft, setTimeLeft] = useState(calculateTimeLeft());
    useEffect(() => {
        const timer = setTimeout(() => {
            setTimeLeft(calculateTimeLeft());
            if (props.remainingTime <= 0) {
                props.setRemainingTime(10);
                if (props.modalVisible) {
                    props.callLockExchangeRate(props.sourceCurrency, props.targetCurrency, props.totalConvertedAmount);

                    let currentDateTime = new Date();
                    let dateTemp  = currentDateTime.toLocaleString("en-US", {timeZone: "Asia/Singapore"});
                    let time = moment(dateTemp).format("hh:mm:ss A") + ' (GMT+8)'
                    props.setTime(time);
                }
            } else {
                if (!props.loading) {
                    if (props.remainingTime > 0) {
                        props.setRemainingTime(props.remainingTime - 1);
                    }
                }
            }
        }, 1000);
        // Clear timeout if the component is unmounted
        return () => clearTimeout(timer);
    });

    useEffect(() => {
        if (props.lockedExchangeRate) {
            //var newTotalTargetAmount = props.totalConvertedAmount*props.lockedExchangeRate.exchangeRate;
            var newTotalTargetAmount = 0;
            for (var i=0; i<props.orders.length; i++) {
                var targetAmount = formatDouble(props.orders[i].convertedAmount * props.lockedExchangeRate.exchangeRate, 2);
                newTotalTargetAmount = newTotalTargetAmount + parseFloat(targetAmount);
            }
            props.setTotalTargetAmount(formatDouble(newTotalTargetAmount, 2));
        }
    }, [props.lockedExchangeRate]);

    if(props.error) {
        let msg = intl.formatMessage({id: "app.modal.bulkfxupdaterxmodal.error"},{orderIds: props.error});
        props.setError({message: msg})
        props.cleanError();
    }
    if(props.success){
        props.setSuccess();
        props.cleanSuccess();
    }

    return (
        <div>
            <Modal
                className="bp-modal"
                title={intl.formatMessage({id: "app.modal.bulkfxupdaterxmodal.bulkfxupdate"})}
                visible={props.modalVisible}
                onOk={() => onModalOk(props, intl)}
                onCancel={() => {
                    props.setTotalSourceAmount(0);
                    props.setTotalTargetAmount(0);
                    props.setTotalConvertedAmount(0);
                    props.setTotalRemitFees(0);
                    props.setModalVisible(false);
                }}
                maskClosable={false}
                destroyOnClose={true}
                width="1024px"
                style={{top: "50px"}}
            >
                <div style={{marginTop: "30px", marginLeft: "20px", marginRight: "20px"}}>
                    <div className="transfer-calculator">
                        <Row className={"amount-panel"}>
                            <Col md={10} className="col-source-amount transfer-details-panel">
                                <Form.Item label={<label style={{ color: "black", fontWeight: "bold" }}><FormattedMessage id="app.modal.bulkfxupdaterxmodal.totalsourceamount"/> </label>}>
                                    <Row gutter={8}>
                                        <Col lg={16} md={13} xs={13}>
                                            <FieldValueVerticalRxCell
                                                value={displayNumberWithComma(props.totalSourceAmount, 2)}
                                                fieldclass="field-value-cell-sendmoney-value"
                                                style={{ width: "200", fontSize: "22px" }}
                                                />

                                        </Col>
                                        <Col lg={8} md={11} xs={11}>
                                            <div style={{ lineHeight:"50px", width: "200", fontSize: "24px" }}>{props.sourceCurrency}</div>
                                        </Col>
                                    </Row>
                                </Form.Item>
                                <div style={{height: "13px"}}>{intl.formatMessage({id: "app.modal.bulkfxupdaterxmodal.totalnumberoforders"}).replace('%number', props.orderIds.length)}</div>
                            </Col>
                            <Col className={"bridge-line"} md={4} style={{marginTop: "30px"}}>
                                <span />
                            </Col>
                            <Col md={10} className="col-target-amount transfer-details-panel">
                                <Form.Item label={<label style={{ color: "black", fontWeight: "bold" }}><FormattedMessage id="app.modal.bulkfxupdaterxmodal.totaltargetamount"/></label>}>
                                    <Row gutter={8}>
                                        <Col lg={16} md={13} xs={13}>
                                            <FieldValueVerticalRxCell
                                                value={displayNumberWithComma(props.totalTargetAmount, 2)}
                                                fieldclass="field-value-cell-sendmoney-value"
                                                style={{ width: "200", fontSize: "22px" }}
                                                />    
                                        </Col>
                                        <Col lg={8} md={11} xs={11}>
                                            <div style={{ lineHeight:"50px", width: "200", fontSize: "24px" }}>{props.targetCurrency}</div>
                                        </Col>
                                    </Row>
                                </Form.Item>
                                <div style={{height: "13px"}}></div>
                            </Col>
                            <Col md={24} className={"col-transfer-detail"}>
                                <div className="transfer-details-panel">
                                    <Row>
                                        <Col md={3} sm={12}></Col>
                                        <Col md={9} sm={12} style={{textAlign: 'center'}}>
                                            <FieldValueVerticalRxCell
                                                title={intl.formatMessage({id: "app.modal.bulkfxupdaterxmodal.totalremitfees"})}
                                                value={props.totalRemitFees}
                                                currency={props.sourceCurrency}
                                                />
                                        </Col>
                                        <Col md={9} sm={9} style={{textAlign: 'center'}}>
                                            <FieldValueVerticalRxCell
                                                title={intl.formatMessage({id: "app.modal.bulkfxupdaterxmodal.totalconvertedamount"})}
                                                value={displayNumberWithComma(props.totalConvertedAmount)}
                                                currency={props.sourceCurrency}
                                                />
                                        </Col>
                                    </Row>
                                    <Row style={{marginTop: "14px"}}>
                                        <Col md={10} sm={12}></Col>
                                        <Col md={8} sm={12}>
                                            <Spin style={{position: "absolute", top: "50px", left: "50px"}} size="large" spinning={props.loading} />
                                            <Progress type="circle" strokeColor="#69C0FF" percent={props.loading ? 0 : props.remainingTime*10} width={132} format={percent => props.loading ? '' : `${percent / 10} sec`} />
                                        </Col>
                                        <Col md={10} sm={12}></Col>
                                    </Row>
                                    <Row style={{marginTop: "14px", minHeight: "50px"}}>
                                        <Col md={9} sm={12}></Col>
                                        <Col md={8} sm={12}>
                                            {props.lockedExchangeRate  &&
                                            <FieldValueVerticalRxCell
                                            value={`1 ${props.sourceCurrency} = ${(props.lockedExchangeRate) ? formatDouble(props.lockedExchangeRate.exchangeRate, 4) : ''} ${props.targetCurrency}`}
                                            fieldclass="field-value-cell-sendmoney-value"
                                            />}
                                        </Col>
                                        <Col md={10} sm={12}></Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                        <div>
                            <FormattedMessage id="app.panel.clienttransfercalculator.updated"/>{' '}<span className="transfer-calculator-timestamp-full">
                            <Icon style={{marginLeft: '10px'}} type="dashboard"></Icon></span>
                            <span style={{marginLeft: '7px'}}>{props.time}</span>
                            <span style={{marginLeft: '15px'}}>{currentDate}</span>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    );
}

const onModalOk = (props, intl) => {
    // validate time
    let currentDateTime = new Date();
    let dateTemp = currentDateTime.toLocaleString("en-US", {timeZone: "Asia/Singapore"});
    let currentTime = moment(dateTemp);
    let startTime = moment(currentTime.format('YYYY-MM-DD') + ' ' + config.bulkFxStartTime);
    let endTime = moment(currentTime.format('YYYY-MM-DD') + ' ' + config.bulkFxEndTime);

    const isPublicHolidays = config.publicHolidays.sg.includes(currentTime.format('YYYY-MM-DD'));
    const isSatSun = currentTime.weekday() === 6 || currentTime.weekday() === 7;
    const isOutsideWindow = (currentTime < startTime || currentTime > endTime);

    if (isPublicHolidays || isSatSun || isOutsideWindow) {
        displayError(intl.formatMessage({id: "app.message.bulkfxupdaterxmodal.bulkfxupdatewindowclosed"}).replace('%bulkFxStartTime', config.bulkFxStartTime).replace('%bulkFxEndTime', config.bulkFxEndTime));
        return;
    } else {
        confirm({
          title: intl.formatMessage({id: "app.message.bulkfxupdaterxmodal.confirmbulkfxupdate"}).replace('%exchangeRate', formatDouble(props.lockedExchangeRate.exchangeRate, 4)).replace('%numberOfOrders', props.orders.length),
          onOk: async () => {
              await props.callUpdateExchangeRate(props.orders, props.lockedExchangeRate.exchangeRate);
              await props.setModalVisible(false);
              await props.onConfirmUpdateExchangeRate();
          }
        });
    }
};

const calculateTimeLeft = () => {
    let year = new Date().getFullYear();
    let difference = +new Date(`10/01/${year}`) - +new Date();
    let timeLeft = {};

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60)
    };
  }

  return timeLeft;
}

const mapStateToProps = (state) => {
    return {
      modalVisible: state.bulkFxUpdate.modalVisible,  
      remainingTime: state.bulkFxUpdate.remainingTime,
      sourceCurrency: state.bulkFxUpdate.sourceCurrency,
      targetCurrency: state.bulkFxUpdate.targetCurrency,
      orderIds: state.bulkFxUpdate.orderIds,
      orders: state.bulkFxUpdate.orders,
      time: state.bulkFxUpdate.time,
      totalSourceAmount: state.bulkFxUpdate.totalSourceAmount,
      totalConvertedAmount: state.bulkFxUpdate.totalConvertedAmount,
      totalTargetAmount: state.bulkFxUpdate.totalTargetAmount,
      totalRemitFees: state.bulkFxUpdate.totalRemitFees,
      lockedExchangeRate: state.bulkFxUpdate.lockedExchangeRate,
      loading: state.bulkFxUpdate.loading,
      error: state.bulkFxUpdate.error,
      success: state.bulkFxUpdate.success,
    };
};
  
const mapDispatchToProps = (dispatch) => {
    return {
      setModalVisible: (modalVisible) => dispatch(setModalVisible(modalVisible)),
      setRemainingTime: (remainingTime) => dispatch(setRemainingTime(remainingTime)),
      setSourceCurrency: (sourceCurrency) => dispatch(setSourceCurrency(sourceCurrency)),
      setTargetCurrency: (targetCurrency) => dispatch(setTargetCurrency(targetCurrency)),
      setOrderIds: (orderIds) => dispatch(setOrderIds(orderIds)),
      setTime: (time) => dispatch(setTime(time)),
      setTotalSourceAmount: (totalSourceAmount) => dispatch(setTotalSourceAmount(totalSourceAmount)),
      setTotalConvertedAmount: (totalConvertedAmount) => dispatch(setTotalConvertedAmount(totalConvertedAmount)),
      setTotalTargetAmount: (totalTargetAmount) => dispatch(setTotalTargetAmount(totalTargetAmount)),
      setTotalRemitFees: (totalRemitFees) => dispatch(setTotalRemitFees(totalRemitFees)),
      callLockExchangeRate: (sourceCurrency, targetCurrency, requestedAmount) => dispatch(callLockExchangeRate(sourceCurrency, targetCurrency, requestedAmount)),
      callUpdateExchangeRate: (orders, newExchangeRate) => dispatch(callUpdateExchangeRate(orders, newExchangeRate)),
      cleanError: () => dispatch(cleanError()),
      cleanSuccess: () => dispatch(cleanSuccess())
    };
};
  
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(BulkFxUpdateRxModal));
